/* eslint-disable @typescript-eslint/no-explicit-any */
import { EnhancedTabs, TabItem } from 'components/enhanced/tabs/EnhancedTabs';
import TenantPage from 'layouts/TenantPage';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { activityService } from 'features/cost-analysis/team/activities/api/activity.service';
import { expertiseService } from 'features/cost-analysis/team/expertises/api/expertise.service';
import toast from 'shared/utils/toast';
import { IActivity } from '../../activities/types';
import ActivitiesTab from '../components/ActivitiesTab';
import ExpertiseForm from '../components/ExpertiseForm';
import { IExpertise } from '../types';

export const ExpertiseView = () => {
  const { t } = useTranslation();
  const translationPrefix = 'pages.expertises.view';
  const { expertiseId } = useParams();

  const [expertise, setExpertise] = useState<IExpertise>();
  const [activities, setActivities] = useState<IActivity[]>([]);

  useEffect(() => {
    if (!expertiseId) return;

    const fetchInitialData = async () => {
      try {
        const [expertiseData, activitiesData] = await Promise.all([
          expertiseService.get(Number(expertiseId)),
          activityService.getAllPaginated(0, 0, { expertise_id: expertiseId })
        ]);

        if (expertiseData) setExpertise(expertiseData);

        const loadedActivities = activitiesData?.results || activitiesData;
        if (Array.isArray(loadedActivities)) {
          setActivities(loadedActivities);
        }
      } catch (error) {
        toast.error(t(`${translationPrefix}.fetchError`));
      }
    };

    fetchInitialData();
  }, [expertiseId]);

  const handleUpdateExpertise = (value: any) => {
    if (!expertise?.id) return;

    expertiseService.update(expertise.id, value).then((res) => {
      if (res) {
        toast.success('Aggiornato con successo');
      }
    });
  };

  const tabConfig: TabItem[] =
    expertise && activities
      ? [
          {
            label: t(`global.base-info`),
            component: <ExpertiseForm expertise={expertise} onSubmit={handleUpdateExpertise} />
          },
          {
            label: t(`${translationPrefix}.activities`),
            disablePadding: true,
            component: (
              <ActivitiesTab
                expertiseId={expertiseId}
                expertise={expertise}
                activities={activities}
                setActivities={setActivities}
              />
            )
          }
        ]
      : [];

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}
      entityCode={expertise?.name}>
      <EnhancedTabs tabs={tabConfig} variant="scrollable" />
    </TenantPage>
  );
};

export default ExpertiseView;
